import React, { useState } from 'react';
import { ListBase, Pagination, Title } from 'react-admin';

import { useTitle } from '@src/hooks/useTitle';
import WithPricingGuard from './WithPricingGuard';
import ItemAdjustedPricesTable from './ItemAdjustedPricesTable';
import ItemAdjustedPricesFilters, { EMPTY_FILTERS } from './ItemAdjustedPricesFilters';
import ItemAdjustedPricesActions from './ItemAdjustedPricesActions';

import type { ItemAdjustedPricesFilterValues } from './ItemAdjustedPricesFilters';

const ItemAdjustedPricesPagination = () => (
  <Pagination rowsPerPageOptions={[25, 50, 100, 200]} />
);

/**
 * Item Adjusted Prices list page.
 *
 * Uses ListBase for offset pagination. Filter state is local and
 * applied client-side within the current server page — the
 * yadjustedPricing API does not support server-side filtering.
 */
const ItemAdjustedPricesList = () => {
  const { title } = useTitle('Item Adjusted Prices');
  const [filters, setFilters] = useState<ItemAdjustedPricesFilterValues>(EMPTY_FILTERS);

  return (
    <WithPricingGuard>
      <Title title={title} />
      <ListBase perPage={50}>
        <div>
          <ItemAdjustedPricesActions />
          <ItemAdjustedPricesFilters filters={filters} onChange={setFilters} />
          <ItemAdjustedPricesTable filters={filters} />
          <ItemAdjustedPricesPagination />
        </div>
      </ListBase>
    </WithPricingGuard>
  );
};

export default ItemAdjustedPricesList;
